import ReactExport from "react-data-export-typescript"

export const ExcelExportChart = ({
    rows, 
    head,  
    title,
    columns,
}) => {
    
    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

    const ButtonLink = () => {
        return (
            <div>
                {title}
            </div>
        )
    }

    return (
        <ExcelFile  
            element = {<ButtonLink />}
            filename={`${'График'} - ${title.toLowerCase()}`}
        >
            <ExcelSheet data={rows} name={title}>
                <ExcelColumn label={'Ось oX'} value={'ox'} />
                <ExcelColumn label={'Ось oY'} value={'oy'} />
            </ExcelSheet>
        </ExcelFile>  
        
    );
}